import React from 'react';

import MARKETBASE_THEME from '@dashboard/contexts/ThemeManager/theme';
import { Button, Tooltip, Typography } from '@mui/material';

import { MONOSPACE_FONT_FAMILY } from '@waypoint/constants';

type Props = {
  label: string;
  tooltipTitle?: string;
  size?: 'sm' | 'md';
};

export default function KeyChip({ label, tooltipTitle = 'Copy to clipboard', size = 'md' }: Props) {
  const [isCopied, setIsCopied] = React.useState(false);

  const copyToClipboard: React.MouseEventHandler<HTMLButtonElement> = async (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    await navigator.clipboard.writeText(label);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <Tooltip title={isCopied ? 'Copied!' : tooltipTitle}>
      <Button size="small" onClick={copyToClipboard} sx={{ bgcolor: 'grey.100', '&:hover': { bgcolor: 'grey.300' } }}>
        <Typography
          component="code"
          sx={{
            fontFamily: MONOSPACE_FONT_FAMILY,
            color: 'text.secondary',
            lineHeight: size == 'sm' ? 1 : 1.4,
            fontSize: size == 'sm' ? MARKETBASE_THEME.typography.pxToRem(11) : MARKETBASE_THEME.typography.pxToRem(12),
          }}
        >
          {label}
        </Typography>
      </Button>
    </Tooltip>
  );
}
